import Header from "../components/header.jsx";
import Sidebar from "../components/sidebar.jsx";
import Payment from "../components/payment.jsx";
import Footer from "../components/footer.jsx";

function PaymentPage() {
    return (
        
        <div className='wrapper'>
          <Header />
          <Sidebar /> 
          <Payment/> 
        </div>
       
      // <Login/>
      );
}
export default PaymentPage;
